import styled from 'styled-components';

export const AboutContainer = styled.section`
  display: flex;
  flex-direction: column;
  /* gap: var(--space-xxxl); */
  /* padding: var(--space-xxxl); */
  @media screen and (max-width: 900px) {
    /* padding: var(--space-xl); */
    gap: var(--space-xxl);
  }
  @media screen and (max-width: 600px) {
    /* padding: var(--space-m); */
    gap: var(--space-xl);
  }
`;

export const FounderSection = styled.div`
  /* display: grid; */
  display: flex;
  flex-direction: column;
  gap: var(--space-xxl);
  /* grid-template-columns: 0.8fr 1.2fr; */
  gap: var(--space-xxl);
  padding-block: var(--space-xl);
  /* background: var(--white); */
  /* border: 1px solid rgba(15, 23, 42, 0.08); */
  /* border-radius: 24px; */
  /* box-shadow: 0 18px 44px rgba(15, 23, 42, 0.06); */

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
    padding: var(--space-l);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
  }
`;

export const FounderIntro = styled.div`
  span {
    color: var(--orange5);

    font-size: 0.78rem;
    font-weight: 900;

    text-transform: uppercase;
    letter-spacing: 0.12em;
  }

  h3 {
    margin: var(--space-xs) 0 var(--space-xxs);

    color: var(--grey7);

    font-size: clamp(1.8rem, 3vw, 2.6rem);
    line-height: 1.05;
    font-weight: 900;

    letter-spacing: -0.03em;
  }

  .founderTitle {
    margin: 0;

    color: var(--grey4);

    font-size: 1rem;
    font-weight: 700;
  }
`;

export const FounderCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  p {
    margin: 0;

    color: var(--grey5);

    font-size: 1rem;
    line-height: 1.85;
    font-weight: 500;
  }
`;

export const SectionHeader = styled.div`
  max-width: 720px;

  h3 {
    margin: var(--space-xs) 0 0;

    color: var(--grey7);

    font-size: clamp(1.8rem, 3vw, 2.6rem);
    line-height: 1.08;
    font-weight: 900;

    letter-spacing: -0.035em;
  }
`;
